export const checkIsSafari = () => {
  if (/iPad/.test(navigator.userAgent)) {
    return false
  } else {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  }
}
